<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";

import axios from "axios";
import moment from "moment";
import Vue from "vue";
import "vue-select/dist/vue-select.css";
import Vuetable from "vuetable-2";
import { required } from "vuelidate/lib/validators";
import Toasted from "vue-toasted";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
// Lets Register a Global Error Notification Toast.
Vue.component("v-select", vSelect);
Vue.use(Toasted);
/**
 * Departamento component
 */
export default {
  page: {
    title: "Información de la compra",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Vuetable, VuetablePagination },
  data() {
    return {
      causa_muerte: "",
      loteId :   this.$route.params.id,
      page_a :   this.$route.params.page,
      lote_a :   this.$route.params.lote,
      arrayMedicina:[],
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      searchLabel: { nombre: "Nombre", value: "nombre" },
      searchType: [{ nombre: "Nombre", value: "nombre" }],


      stock: [],
      url: 0,
      iddetalle: 0,
      cantidad: 0,
      idstock: 0,
      idubicacion: 0,
      formMedicina:{
        medicina: '',
        medicinaid: -1,
        cantidad: 0,
      },
      formPro: {
        no_lote: "",
        no_animales: "",
        fecha_inicio: "",
        tipo_lote: "",
        inversion_comida: "",
        inversion_economica: "",
        state: true,
        credito: true,
        inversion_economica_m : 0,
        inversion_medicina: 0,
        id: 0,
        idCerdo : 0,
      },
      detalleorden: [],
      fildsFichaTecnica:[
      {
          name: "fecha_inicio_ciclo",
          sortField: "fecha_inicio_ciclo",
          title: "Fecha Inicio",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "fecha_inseminacion",
          sortField: "fecha_inseminacion",
          title: "Fecha Inseminacion",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "fecha_pre_parto",
          sortField: "fecha_pre_parto",
          title: "Fecha pre Parto",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "fecha_parto",
          sortField: "fecha_parto",
          title: "Fecha Parto",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "cantidad_vivos",
          sortField: "cantidad_vivos",
          title: "Vivos ",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "cantidad_muertos",
          sortField: "cantidad_muertos",
          title: "Muertos",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "total_peso",
          sortField: "total_peso",
          title: "Total Peso ",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "peso_promedio",
          sortField: "peso_promedio",
          title: "Peso Promedio ",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "fecha_embarazo",
          sortField: "fecha_embarazo",
          title: "Fecha Preñez ",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "intentos_embarazo",
          sortField: "intentos_embarazo",
          title: "Intentos Preñez ",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "cerdo_padre",
          sortField: "cerdo_padre",
          title: "Cerdo Padre ",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
      ],
      fieldsHistory:[
      {
          name: "concentrado.nombre_producto",
          sortField: "concentrado.nombre_producto",
          title: "Concentrado",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "lote.no_lote",
          sortField: "lote.no_lote",
          title: "Lote",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "fecha",
          sortField: "fecha",
          title: "Fecha de asignacion",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "inversion_comida",
          sortField: "inversion_comida",
          title: "Inversion comida",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "inversion_economica",
          sortField: "inversion_economica",
          title: "Inversion economica ",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
      ],
      fieldsHistoryMedicina:[
      {
          name: "medicina.nombre_producto",
          sortField: "medicina.nombre_producto",
          title: "Medicina",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "lote.no_lote",
          sortField: "lote.no_lote",
          title: "Lote",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "fecha",
          sortField: "fecha",
          title: "Fecha de asignacion",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "inversion_cm",
          sortField: "inversion_cm",
          title: "Inversion cm",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "inversion_economica",
          sortField: "inversion_economica",
          title: "Inversion economica ",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
      ],
      fields: [
          {
          name: "opciones",
          sortField: "opciones",
          title: "Opciones",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "5%",
        },
        
        {
          name: "cerdo.codigo",
          sortField: "cerdo.codigo",
          title: "Código",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "cerdo.raza",
          sortField: "cerdo.raza",
          title: "Raza",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        // {
        //   name: "cerdo.semanas",
        //   sortField: "cerdo.semanas",
        //   title: "Semnas ingreso",
        //   titleClass: "",
        //   dataClass: "list-item-heading",
        //   width: "10%",
        // },

        // {
        //   name: "precio_compra",
        //   sortField: "precio_compra",
        //   title: "Precio Compra",
        //   titleClass: "",
        //   dataClass: "list-item-heading",
        //   width: "15%",
        // },
        {
          name: "cerdo.partos",
          sortField: "cerdo.partos",
          title: "Partos",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "5%",
        },
        {
          name: "inversion",
          sortField: "inversion",
          title: "Inversion",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "5%",
        },
        {
          name: "precio_compra",
          sortField: "precio_compra",
          title: "Precio Compra",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "5%",
        },

        {
          name: "fecha_ingreso",
          sortField: "fecha_ingreso",
          title: "Fecha Ingreso",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },

        {
          name: "fecha_salida",
          sortField: "fecha_salida",
          title: "Fecha Salida",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "vida_actual",
          sortField: "vida_actual",
          title: "Vida Actual",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "ganancia",
          sortField: "ganancia",
          title: "Ganancias",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "muerte",
          sortField: "muerte",
          title: "Muerte",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "estado_activo",
          sortField: "estado_activo",
          title: "Estado",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "embarazo",
          sortField: "embarazo",
          title: "Preñez",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "tipo_animal",
          sortField: "tipo_animal",
          title: "Cerdo",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
       
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      formget: {
        nombre: "",
        state: true,
      },
      formSub: {
        nombre: "",
        cantidaddepa: "",
        state: true,
        id: 0,
      },
      updating: false,
      title: "Información",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Información",
          active: true,
        },
      ],
      loadingtable: false,

      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      showModalS: false, //Subir
      showModalI: false, //Informacion parto
      showModalZ: false,
      cerdoId : 0,
      formMedicamento: {
        nombre: "",
        state: true,
        cantidad : 0,
        medicamento: "",
        medicamentoId: -1,
        id: 0,
      },
      data: [],
      idlote:0,
      tipoAnimalArray: [],
      tipoAnimal:null,
      apiBase: process.env.VUE_APP_URL + "asignacion_alimento/historyAlimentCerdo",
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 100,
      totalInversionM: 0,
      totalInversionCo: 0,
      GranTotal: 0,
      GranTotalLechones : 0,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
      totalcomida: 0,
      totalinversion: 0,
      vanderaExistencia: false,
      totalGanancias:0,
      animalParto: {
        cerdo :{

        },
        parto : {
          inseminacion: {},
          cerdo : {},
        }
      }
    };
  },
  validations: {
    formMedicamento: {
      cantidad: {
        required,
      },
    },
    tipoAnimal: {
      required,
    },
    formMedicina: {
      medicina: {
        required,
      },
    },
  },
  mounted() {
    console.log(this.page_a);
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  watch: {},
  methods: {

    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES
    sumarInversionEconomica(array) {
      // Si el array está vacío, retorna 0
      if (!array || array.length === 0) {
        return 0;
      }

      // Suma los valores de inversion_economica, validando que sea un número
      const total = array.reduce((suma, item) => {
        // Validar que el campo existe y es un número
        const valor = parseFloat(item.inversion_economica);
        return suma + (isNaN(valor) ? 0 : valor); // Si no es un número, suma 0
      }, 0);

      return total;
    },
    calculoInversion(animal_comidas, asignacion_medicinas){
        // console.log(animal_comidas, asignacion_medicinas);
        const totalSumaComida = this.sumarInversionEconomica(animal_comidas);
        const totalSumaMedicina = this.sumarInversionEconomica(asignacion_medicinas);
        const totalInversion = totalSumaComida + totalSumaMedicina;
        const total =this.money(totalInversion);
        // console.log(total);
        return total;
    },
    calcularGranTotalALV(detalle) {
    this.GranTotalLechones = detalle
        .slice(1) // Ignora la primera posición
        .reduce((acumulador, item) => {
            const total = this.converMaskToNumberxd(
                this.calculoInversion(
                    item.cerdo.animal_comidas,
                    item.cerdo.asignacion_medicinas
                )
            );
            return acumulador + parseFloat(total);
        }, 0);
    },
    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
          number.charAt(i) === "Q" ||
          number.charAt(i) === "€" ||
          number.charAt(i) === "$" ||
          number.charAt(i) === "%" ||
          number.charAt(i) === "," ||
          number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    desactivate(){
     axios
          .put(process.env.VUE_APP_URL + "lote_animal/update_dead_animal", {
            id: this.cerdoId,
            causa_muerte: this.causa_muerte,
          },{
            headers: { "x-token": this.userT.token}
          })
          .then(() => {
             this.showModalS = false;
             Vue.toasted.error(("Cerdo Eliminado"),this.options);
             this.detalle();
             this.$refs.vuetable.refresh();
             this.causa_muerte = "";
            //  this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
             Vue.toasted.error("Error para desactivar",this.options);
          
          });
  },
    onActionClicked(action, data) {

      if (action == "new-item") {

        this.selectTipoAnimal();
        this.tipoAnimal = null;
        this.formMedicamento.nombre = "";
        this.formMedicamento.cantidad = "";
        this.formMedicamento.medicamento = "";
        this.formMedicamento.medicamentoId = -1;
        this.showModalN = true;
      }
      if(action == "inversiones-item"){
        // console.log(console.log(data))
        const madre = data.cerdo.tipoAnimalId == 1 ? true : false
        this.cerdoId = data.cerdoId;
        
        this.apiBase = process.env.VUE_APP_URL +"asignacion_alimento/historyAlimentCerdo?madre="+madre;
     
        this.showModalA = true;
      }
      if(action == "ficha-tecnica"){
        this.cerdoId = data.cerdoId;
        this.apiBase = process.env.VUE_APP_URL + "proceso_partos/get";
        this.showModalZ = true;
      }
      if(action == "medicamento-item"){
        this.cerdoId = data.cerdoId;
        this.apiBase = process.env.VUE_APP_URL + "asignacion_medicina/history";
        this.showModalD = true;
      }
      if(action == "parto-item"){
        this.showModalI = true;
        this.viewPartoByCerdo(data.cerdoId);
      }
      if(action == 'animal-muerto'){
        this.showModalS = true;
        this.cerdoId = data.cerdoId;
      }
    },
    viewPartoByCerdo(id){
      axios
        .get(
          process.env.VUE_APP_URL +
            "partos/view_parto?id=" +id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.animalParto = response.data;
          this.showModalI = true;
          // console.log(response) 
      
        });
    
    },
    async getTotalInversionEconomica(){
      const url = `${process.env.VUE_APP_URL}asignacion_alimento/historyAlimentCerdo?idanimal=${this.formPro.idCerdo}&madre=true`;
      var response = await axios
        .get(url,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        this.totalInversionCo  = response.data.total1.totalInversionEconomica;
    
    },
    async getTotalInversionEconomicaM(){
      const url = `${process.env.VUE_APP_URL}asignacion_medicina/history?idanimal=${this.formPro.idCerdo}`;
      const response =  await axios
        .get(url,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.totalInversionM = response.data.total1.totalInversionEconomica;
    
    },
    
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date)
        .locale("es")
        .utc()
        .format("MMM Do YYYY");
    },
    async detalle() {
      
        // console.log(this.$route.params.id)
      axios
        .get(
          process.env.VUE_APP_URL +
            "lote_animal/findByIdLoteAnimal?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          // console.log(response.data.data);
          this.formPro.no_lote = response.data.data.no_lote;
          this.formPro.no_animales = response.data.data.no_animales;
          this.formPro.fecha_inicio = this.showDate(response.data.data.fecha_inicio);
          this.formPro.tipo_lote = response.data.data.tipo_lote;
          this.formPro.inversion_comida = response.data.data.inversion_comida;
          this.formPro.inversion_economica = response.data.data.inversion_economica;
          this.formPro.inversion_economica_m = response.data.data.inversion_economica_m
          
          ;
          this.formPro.inversion_medicina = response.data.data.inversion_medicina;
          this.idlote = response.data.data.id;
          this.formPro.idCerdo = response.data.data.lote_animals[0].cerdoId;


          this.detalleorden = response.data.data.lote_animals;
      
        }).finally(async ()=>{
          this.calculoGanancias();
          await this.getTotalInversionEconomica();
          await this.getTotalInversionEconomicaM();
          this.GranTotal = (parseFloat(this.totalInversionM ) + parseFloat(this.totalInversionCo)).toFixed(2);
          this.calcularGranTotalALV(this.detalleorden);
        });
    },
    calculoGanancias(){
      const gananciasValidas = this.detalleorden.filter(detalle => {
        const ganancia = detalle.cerdo.ganancia;
        const fechaVenta = detalle.fecha_venta;
        return ganancia && ganancia !== 'null' && fechaVenta && fechaVenta !== 'null';
      });

      const total = gananciasValidas.reduce((acc, detalle) => {
        return acc + parseFloat(detalle.cerdo.ganancia);
      }, 0);

      this.totalGanancias = total.toFixed(2);
    },
    calcularTiempoVidaCerdo(semanasIniciales, fechaIngreso) {
    // Convertir la fecha de ingreso a un objeto Date
            const fechaIngresoDate = new Date(fechaIngreso);
            
            // Obtener la fecha actual
            const fechaActual = new Date();
            
            // Calcular la diferencia en milisegundos entre la fecha actual y la fecha de ingreso
            const diferenciaMilisegundos = fechaActual - fechaIngresoDate;
            
            // Convertir la diferencia de milisegundos a días
            const diferenciaDias = Math.floor(diferenciaMilisegundos / (1000 * 60 * 60 * 24));
            
            // Convertir los días a semanas y días restantes
            const semanasDesdeIngreso = Math.floor(diferenciaDias / 7);
            const diasRestantes = diferenciaDias % 7;
            
            // Calcular las semanas totales de vida
            const semanasTotales = parseInt(semanasIniciales) + semanasDesdeIngreso;
            
            // Retornar el mensaje con el tiempo de vida
            return `${semanasTotales} semanas y ${diasRestantes} días`;
        },
        getDatosMedicina(val1){
        let me = this;
        me.loading = true;
        if (val1 == null || val1 == ''){
            me.formMedicina.medicina = '';
            me.formMedicina.medicinaid = -1;
        }
        else {
            me.formMedicina.medicinaid = val1.id;
        }
    },
    selectMedicina(search, loading){
                let me = this;
                loading(true);
                let url =  process.env.VUE_APP_URL + '/medicina/select_medicina?search=' + search;
                axios.get(url,{
                    headers: { "x-token": this.userT.token },
                }).then(function (response) {
                    console.log(response);
                    me.arrayMedicina = response.data.data.data;
                    loading(false);
                })
                .catch(function (error) {
                    console.log({error});
                });
    },
    selectTipoAnimal(){
                let me = this;
                let url =  process.env.VUE_APP_URL + '/tipo_animal/select' ;
                axios.get(url,{
                    headers: { "x-token": this.userT.token },
                }).then(function (response) {
                    // console.log(response);
                    me.tipoAnimalArray = response.data.data;
                   
                })
                .catch(function (error) {
                    console.log({error});
                });
    },
    validaciones(opc) {
      this.submitted = true;
      this.$v.$touch();
      // console.log(this.$v.$invalid, this.repit);
      if (this.$v.$invalid) {
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
      }
    },
    async validarExistencia() {
      
      const { medicinaid} = this.formMedicina;
      const { cantidad  } = this.formMedicamento;
      
      try{
        this.vanderaExistencia = false;
       await axios
        .post(process.env.VUE_APP_URL + "medicina/valida_existencia", {
            id : medicinaid, cantidad
        }, {
                headers: { "x-token": this.userT.token },
              });
              this.submitted = false;
          this.vanderaExistencia = true;
          this.showModalL = false
            

      }catch(error){
        if (error.response && error.response.data) {
            this.errorMessage = error.response.data.error; 
            // Accede al mensaje de error dentro de la respuesta
            } else {
            this.errorMessage = 'Error desconocido'; 
            }
            console.log(error);
            Vue.toasted.error(this.errorMessage, this.options);
      }
              
    },
    async save(){
      const { medicinaid,  medicina} = this.formMedicina;
      const { cantidad  } = this.formMedicamento;
      const inversion_economica = ((parseFloat(medicina.precio_compra) / parseFloat(medicina.existencia_cm)) * cantidad).toFixed(2);
      // console.log(this.tipoAnimal);
      await this.validarExistencia();
      if(!this.vanderaExistencia){
        return;
      }

      const me = this;
      axios
        .post(process.env.VUE_APP_URL + "asignacion_medicina/store", {
          cantidad_cm : parseFloat(cantidad).toFixed(2),
          medicinaId : medicinaid,
          tipoAnimalId : this.tipoAnimal.id,
          tipo_lote : this.formPro.tipo_lote, 
          inversion_economica: inversion_economica,
          loteId : me.idlote,
           
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then((response) => {
          console.log(response);
          Vue.toasted.success(medicina.nombre_producto + " Guardado", this.options);
          me.$refs.vuetable.refresh();
          this.showModalN = false;
          // this.limpiarModal();
          this.submitted = false;
          this.detalle();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    getRowClass(status) {
      // console.log(status)
      if(status.estado_activo){
        console.log('activo')
        return 'active-row';
      }
      else{
        console.log('f')
        return 'inactive-row';
      }
     
    },
    //paginacion 
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
        //  console.log(paginationData);
      const {totalInversionComida,
        totalInversionEconomica} = paginationData.total1
        // console.log(totalInversionEconomica)
      this.totalcomida = totalInversionComida;
      this.totalinversion = totalInversionEconomica == null || totalInversionEconomica == '' ? 0 : totalInversionEconomica;
// 
      this.$refs.pagination.setPaginationData(paginationData);
    },
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            // tipo_lote : this.banderaTipo == true ? this.searchLabelLote.nombre : "",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            idanimal : this.cerdoId
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            // tipo_lote : this.banderaTipo == true ? this.searchLabelLote.nombre : "",
            limite: this.perPage,
            search: this.search,
            idanimal : this.cerdoId
          };
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <!-- update animal -->
         <!-- Ficha tecnica  -->
         <b-modal
          centered
          v-model="showModalZ"
          title="Historial de partos"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
            size="xl"
        >
         <!-- Cuadros de resumen -->
         <div class="d-flex justify-content-center mb-3">
            <!-- <div class="summary-box bg-light-blue text-dark p-3 rounded mx-2">
              <h5>Total Comida</h5>
              <p>{{ totalcomida }} LB</p>
            </div>
            <div class="summary-box bg-light-green text-dark p-3 rounded mx-2">
              <h5>Total Inversión</h5>
              <p>{{ money(totalinversion) }}</p>
            </div> -->
          </div>
          <form>
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-url="apiBase"
                :reactive-api-url="true"
                :fields="fildsFichaTecnica"
                :http-options="httpOptions"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
              <div slot="fecha_inicio_ciclo" slot-scope="props">
                  {{
                     showDate(props.rowData.fecha_inicio_ciclo)
                  }}
                </div>
              <div slot="fecha_inseminacion" slot-scope="props">
                  {{
                     showDate(props.rowData.fecha_inseminacion)
                  }}
                </div>
              <div slot="fecha_pre_parto" slot-scope="props">
                  {{
                     showDate(props.rowData.fecha_pre_parto)
                  }}
                </div>
              <div slot="fecha_parto" slot-scope="props">
                  {{
                     showDate(props.rowData.fecha_parto)
                  }}
                </div>
              <div slot="fecha_embarazo" slot-scope="props">
                  {{
                     showDate(props.rowData.fecha_embarazo)
                  }}
                </div>
              <div slot="intentos_embarazo" slot-scope="props">
                  {{
                     parseInt(props.rowData.intentos_embarazo)
                  }}
                </div>
              <div slot="cerdo_padre" slot-scope="props">
                  {{
                     (props.rowData.cerdo_padre)
                  }}
                </div>

              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </form>
        </b-modal>
          <!-- fin ficha tecnica -->
        <!-- Modal para Desactivar -->
        <b-modal
          centered
          v-model="showModalS"
          title="Marcar Animal como muerto"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea marcar el animal como muerto?</h4>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Causa muerte</label>
                  <input
                    id="name"
                    v-model="causa_muerte"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese la causa de muerte"
                  />
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalS = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="desactivate"
                >Desactivar</b-button
              >
            </div>
          </form>
        </b-modal>
        <!-- fin -->
        <b-modal
          centered
          v-model="showModalI"
          title="Información de Parto"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
            size="xl"
        >
         <!-- Cuadros de resumen -->
         <div class="d-flex justify-content-center mb-3">
          <div role="tablist">
                        <b-card no-body class="mb-1 shadow-none">
                          <b-card-header header-tag="header" role="tab">
                            <h6 class="m-0">
                              <a
                                v-b-toggle.accordion-1
                                class="text-dark"
                                href="javascript: void(0);"
                                ><i
                                  class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                                ></i
                                >Detalles Generales</a
                              >
                            </h6>
                          </b-card-header>
                          <b-collapse
                            id="accordion-1"
                            visible
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-card-body style=" padding-top: 0px;padding-bottom: 0px;">
                              <b-card-text>
                                <div class="text-center">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <div v-if="animalParto && animalParto.cerdo">
                                        <p class="text-muted mb-2">Codigo cerdo</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.cerdo.codigo }}
                                        </h5>
                                      </div>
                                      <div v-else>
                                        <p class="text-muted mb-2">Codigo cerdo</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.codigo }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <div v-if=" animalParto.cerdo">
                                        <p class="text-muted mb-2">Fecha Nacimiento</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.cerdo.fecha_ingreso }}
                                        </h5>
                                      </div>
                                      
                                      <div v-else>
                                        <p class="text-muted mb-2">Fecha Nacimiento</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.fecha_ingreso }}
                                        </h5>
                                      </div>

                                    </div>
                                    <div class="col-sm-4">
                                      <div v-if="animalParto.cerdo">
                                        <p class="text-muted mb-2" >Causa de muerte</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.causa_muerte }}

                                        </h5>
                                      </div>
                                      <div v-else>
                                        <p class="text-muted mb-2" >Causa de muerte</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.causa_muerte }}

                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <div v-if=" animalParto.cerdo">
                                        <p class="text-muted mb-2">Raza</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.cerdo.raza }}
                                        </h5>
                                      </div>
                                      <div v-else>
                                        <p class="text-muted mb-2">Raza</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.raza }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <div  v-if=" animalParto.cerdo">
                                        <p class="text-muted mb-2">Tipo Nacimiento</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.estado_nacimiento }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4"  v-if=" animalParto.cerdo">
                                      <div>
                                        <p class="text-muted mb-2">Tipo Nacimiento</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.peso_nacimiento }}
                                        </h5>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                        <b-card no-body class="mb-1 shadow-none">
                          <b-card-header header-tag="header" role="tab">
                            <h6 class="m-0">
                              <a
                                v-b-toggle.accordion-2
                                class="text-dark"
                                href="javascript: void(0);"
                                ><i
                                  class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                                ></i
                                >Detalles Parto</a
                              >
                            </h6>
                          </b-card-header>
                          <b-collapse
                            id="accordion-2"
                            visible
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-card-body style=" padding-top: 0px;padding-bottom: 0px;">
                              <b-card-text>
                                <div class="text-center">
                                  <div class="row">
                                    <div class="col-sm-4">
                                      <div v-if="animalParto.parto">
                                        <p class="text-muted mb-2">Fecha parto</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.parto.fecha_parto }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <div v-if=" animalParto.parto">
                                        <p class="text-muted mb-2">No. Parto</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.parto.no_parto }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <div  v-if="animalParto.parto">
                                        <p class="text-muted mb-2">Cerdo Madre</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.parto.cerdo.codigo }}
                                        </h5>
                                      </div>
                                     
                                    </div>
                                    <div class="col-sm-4">
                                      <div v-if="animalParto.parto">
                                        <p class="text-muted mb-2">Lote de parto</p>
                                        <h5 v-if="animalParto.parto" class="font-size-15">
                                          <!-- {{ animalParto.parto.lote.no_lote }} -->
                                        </h5>
                                      </div>
                                     
                                    </div>
                                    
                                    <div class="col-sm-4">
                                      <div v-if=" animalParto.parto">
                                        <p class="text-muted mb-2">Raza</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.parto.cerdo.raza }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <div  v-if="animalParto.parto">
                                        <p class="text-muted mb-2">Fecha Inseminacion</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.parto.inseminacion.fecha }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <div  v-if="animalParto.parto">
                                        <p class="text-muted mb-2">No. Inseminacion</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.parto.inseminacion.no_inseminacion }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="col-sm-4">
                                      <div  v-if="animalParto.parto">
                                        <p class="text-muted mb-2">Costos Inseminacion</p>
                                        <h5 class="font-size-15">
                                          {{ animalParto.parto.inseminacion.costos }}
                                        </h5>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                      </div>
          </div>
        </b-modal>

        <b-modal
          centered
          v-model="showModalA"
          title="Historial de Alimentos"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
            size="xl"
        >
         <!-- Cuadros de resumen -->
         <div class="d-flex justify-content-center mb-3">
            <div class="summary-box bg-light-blue text-dark p-3 rounded mx-2">
              <h5>Total Comida</h5>
              <p>{{ totalcomida }} LB</p>
            </div>
            <div class="summary-box bg-light-green text-dark p-3 rounded mx-2">
              <h5>Total Inversión</h5>
              <p>{{ money(totalinversion) }}</p>
            </div>
          </div>
          <form>
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable2"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-url="apiBase"
                :reactive-api-url="true"
                :fields="fieldsHistory"
                :http-options="httpOptions"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
              <div slot="inversion_comida" slot-scope="props">
                  {{
                    props.rowData.inversion_comida + ' LB'
                  }}
                </div>
              <div slot="inversion_economica" slot-scope="props">
                  {{
                     money(props.rowData.inversion_economica)
                  }}
                </div>
              <div slot="fecha" slot-scope="props">
                  {{
                     showDate(props.rowData.fecha)
                  }}
                </div>

              </vuetable>
              <div style="text-align: center; padding-top: 30px;">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </form>
        </b-modal>
        <!-- Inversion medicina  -->
        <b-modal
          centered
          v-model="showModalD"
          title="Historial de Alimentos"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
            size="xl"
        >
         <!-- Cuadros de resumen -->
         <div class="d-flex justify-content-center mb-3">
            <div class="summary-box bg-light-blue text-dark p-3 rounded mx-2">
              <h5>Total Medicina</h5>
              <p>{{ totalcomida }} CM</p>
            </div>
            <div class="summary-box bg-light-green text-dark p-3 rounded mx-2">
              <h5>Total Inversión</h5>
              <p>{{ money(totalinversion) }}</p>
            </div>
          </div>
          <form>
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable1"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-url="apiBase"
                :reactive-api-url="true"
                :fields="fieldsHistoryMedicina"
                :http-options="httpOptions"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
              <div slot="inversion_cm" slot-scope="props">
                  {{
                    props.rowData.cantidad_cm + ' CM'
                  }}
                </div>
              <div slot="inversion_economica" slot-scope="props">
                  {{
                     money(props.rowData.inversion_economica)
                  }}
                </div>
              <div slot="fecha" slot-scope="props">
                  {{
                     showDate(props.rowData.fecha)
                  }}
                </div>

              </vuetable>
              <div style="padding-top: 30px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </form>
        </b-modal>
        
        <b-modal
          centered
          v-model="showModalN"
          title="Nuevo Asignacion Medicamento"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        
        >
          <form @submit.prevent="validaciones('save')">
            <div class="row">
              <div class="col-12">
                <div class="col-mb-3">
                        <div>
                        <p class="text-muted mb-2">Tipo Animal</p>
                        <select
                         v-model.trim="$v.tipoAnimal.$model"
                                 :state="!$v.tipoAnimal.$error"
                        class="form-control">
                        <option v-for="(tipo) in tipoAnimalArray" :key="tipo.id" :value="tipo">
                          {{ tipo.nombre }}
                        </option>
                      </select>
                        <div
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.tipoAnimal.$error &&
                              !$v.tipoAnimal.required,
                          }"
                        >
                          Debe seleccionar un tipo de animal
                        </div>
                      </div>
                </div>
                <div class="col-mb-3">
                        <div>
                        <p class="text-muted mb-2">Medicina</p>
                        <v-select
                          v-model.trim="$v.formMedicina.medicina.$model"
                          :state="!$v.formMedicina.medicina.$error"
                          :options="arrayMedicina"
                          @search="selectMedicina"
                            @input="getDatosMedicina"
                          placeholder="Buscar Medicamentos..."
                          label="nombre_producto"
                        >
                        </v-select>
                        <div
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.formMedicina.medicina.$error &&
                              !$v.formMedicina.medicina.required,
                          }"
                        >
                          Debe seleccionar un medicamento
                        </div>
                      </div>
                </div>
                <div class="mb-3">
                  <label for="name">Cantidad en cm</label>
                  <input
                    id="name"
                    v-model="$v.formMedicamento.cantidad.$model"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese un cantidad"
                    :class="{
                      'is-invalid': $v.formMedicamento.cantidad.$error,
                    }"
                    @input="$v.formMedicamento.cantidad.$touch()"
                  />
                  <div
                    v-if="
                      $v.formMedicamento.cantidad.$error &&
                      !$v.formMedicamento.cantidad.required
                    "
                    class="invalid-feedback"
                  >
                    La cantidad en cm es obligatoria.
                  </div>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalN = false"
                >Cerrar</b-button
              >
              <b-button type="submit" variant="success" class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <div class="card" style="margin-bottom: 0px;margin-top: 0px;">
          <div class="card-body" style=" padding-top: 0px;padding-bottom: 0px;">
            <div class="">
              <div class="row justify-content-center">
                <div class="">
                  <div class="text-center" >
                    <div class=""></div>
                  </div>
                  <hr />
                  <div class="card" style="margin-bottom: 0px;margin-top: 0px;">
                    <div class="card-body" style=" padding-top: 0px;padding-bottom: 0px;">
                      <div class="text-center">
                        <div class="row">
                          <div class="col-sm-8 ">
                            <h4 class="card-title">Detalles de Lote</h4>
                          </div>

                          <div class="col-sm-4">
                            <div>
                              <router-link
                                :to="{
                                  name: 'asignacion_corrales',
                                  params: { page_a : page_a, lote_a : lote_a},

                                }"
                              >
                                <b-button
                                  variant="outline-primary"
                                  type="button"
                                  class="btn btn-rounded mb-1 me-2"
                                >
                                  <i class="mdi mdi-arrow-collapse-left"></i>
                                  Regresar
                                </b-button>
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div role="tablist">
                        <b-card no-body class="mb-1">
                          <b-card-header header-tag="header" role="tab">
                            <h6 class="m-0">
                              <a
                                v-b-toggle.accordion-5
                                class="text-dark"
                                href="javascript: void(0);"
                                ><i
                                  class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                                ></i
                                >Detalles Generales</a
                              >
                            </h6>
                          </b-card-header>
                          <b-collapse
                            id="accordion-5"
                            visible
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-card-body style=" padding-top: 0px;padding-bottom: 0px;">
                              <b-card-text>
                                <div class="text-center">
                                  <div class="row">
                                      <div class="container-main">
                                        <div class="row">
                                          <div class="col-sm-4">
                                            <div class="info-box">
                                              <p class="text-muted mb-2">No. Lote</p>
                                              <h5 class="font-size-15">{{ formPro.no_lote }}</h5>
                                            </div>
                                          </div>
                                          <div class="col-sm-4">
                                            <div class="info-box">
                                              <p class="text-muted mb-2">No. Animales</p>
                                              <h5 class="font-size-15">{{ formPro.no_animales }}</h5>
                                            </div>
                                          </div>
                                          <div class="col-sm-4" v-if="formPro.no_animales > 0">
                                            <div class="info-box">
                                              <p class="text-muted mb-2">Medicamentos</p>
                                              <h5 class="font-size-15">
                                                <b-button @click="onActionClicked('new-item')" variant="outline-primary" class="btn btn-rounded mb-1 me-2">
                                                  <i class="mdi mdi-arrow-collapse"></i> Asignar medicamento
                                                </b-button>
                                              </h5>
                                            </div>
                                          </div>
                                          <div class="col-sm-4" v-if="formPro.no_animales == 1 && formPro.tipo_lote == 'Lactancia'">
                                            <div class="info-box">
                                              <p class="text-muted mb-2">Proceso de parto</p>
                                              <h5 class="font-size-15">
                                                <router-link class="d-grid gap-2" :to="{ name: 'new_parto', params: { idlote: idlote, idcerdo: formPro.idCerdo } }">
                                                  <b-button variant="outline-danger" class="btn btn-rounded mb-1 me-2">
                                                    <i class="mdi mdi-arrow-collapse"></i> Proceso de parto
                                                  </b-button>
                                                </router-link>
                                              </h5>
                                            </div>
                                          </div>
                                          <div class="col-sm-4" v-if="formPro.no_animales == 1 && (formPro.tipo_lote == 'Lactancia' || formPro.tipo_lote == 'Gestacion')">
                                            <div class="info-box">
                                              <p class="text-muted mb-2">Proceso Descarte</p>
                                              <h5 class="font-size-15">
                                                <router-link class="d-grid gap-2" :to="{ name: 'new_descarte', params: { idlote: idlote, idcerdo: formPro.idCerdo } }">
                                                  <b-button variant="outline-danger" class="btn btn-rounded mb-1 me-2">
                                                    <i class="mdi mdi-arrow-collapse"></i> Proceso Descarte
                                                  </b-button>
                                                </router-link>
                                              </h5>
                                            </div>
                                          </div>
                                          <div class="col-sm-4" v-if="formPro.no_animales >= 1 && formPro.tipo_lote == 'Reemplazo'">
                                            <div class="info-box">
                                              <p class="text-muted mb-2">Proceso de parto</p>
                                              <h5 class="font-size-15">
                                                <router-link class="d-grid gap-2" :to="{ name: 'new_traslado_gestacion', params: { idlote: idlote, idcerdo: formPro.idCerdo } }">
                                                  <b-button variant="outline-danger" class="btn btn-rounded mb-1 me-2">
                                                    <i class="mdi mdi-arrow-collapse"></i>Traslado Gestacion
                                                  </b-button>
                                                </router-link>
                                              </h5>
                                            </div>
                                          </div>
                                          <div class="col-sm-3">
                                              <div class="info-box">
                                                <p class="text-muted mb-2">Fecha Inicio</p>
                                                <h5 class="font-size-15">{{ formPro.fecha_inicio }}</h5>
                                              </div>
                                            </div>
                                            <div class="col-sm-3" v-if = " formPro.no_animales >1 && formPro.tipo_lote == 'Lactancia' ">
                                                <div >
                                                  <p class="text-muted mb-2">Reacomodo</p>
                                                  <h5 class="font-size-15">
                                                    <router-link
                                                            :to="{
                                                            name: 'new_reacomdo',
                                                            params: { idlote: loteId }
                                                          }"
                                                        >
                                                          <button
                                                              v-b-modal.modalSave
                                                              type="button"
                                                              class="btn btn-success btn-rounded mb-2 me-2"
                                                          >
                                                            <b>Reacomodo animales</b>&nbsp;&nbsp;<i
                                                              class="bx bxs-plus-circle"
                                                          ></i>
                                                          </button>
                                                        </router-link>
                                                  </h5>
                                                </div>
                                              </div>
                                              <div class="col-sm-3" v-if = " formPro.no_animales >1 && formPro.tipo_lote == 'Lactancia' ">
                                                <div >
                                                  <p class="text-muted mb-2">Corral Destete</p>
                                                  <h5 class="font-size-15">
                                                    <router-link
                                                            :to="{
                                                            name: 'new_destete',
                                                            params: { idlote: loteId }
                                                          }"
                                                        >
                                                          <button
                                                              v-b-modal.modalSave
                                                              type="button"
                                                              class="btn btn-info btn-rounded mb-2 me-2"
                                                          >
                                                            <b>Destete animales</b>&nbsp;&nbsp;<i
                                                              class="bx bxs-plus-circle"
                                                          ></i>
                                                          </button>
                                                        </router-link>
                                                  </h5>
                                                </div>
                                              </div>
                                              <div class="col-sm-3" v-if = " formPro.no_animales >1 && formPro.tipo_lote == 'Lactancia'|| formPro.tipo_lote == 'Destete' ">
                                                <div >
                                                  <p class="text-muted mb-2">Traslado 21 Dias</p>
                                                  <h5 class="font-size-15">
                                                    <router-link
                                                            :to="{
                                                            name: 'new_traslado_21',
                                                            params: { idlote: loteId }
                                                          }"
                                                        >
                                                          <button
                                                              v-b-modal.modalSave
                                                              type="button"
                                                              class="btn btn-danger btn-rounded mb-2 me-2"
                                                          >
                                                            <b>Lechon Engorde 21 Dias</b>&nbsp;&nbsp;<i
                                                              class="bx bxs-plus-circle"
                                                          ></i>
                                                          </button>
                                                        </router-link>
                                                  </h5>
                                                </div>
                                              </div>
                                        </div>

                                        <div class="text-center">
                                          <div class="row">
                                           
                                            <div class="col-sm-3">
                                              <div class="info-box">
                                                <p class="text-muted mb-2">Tipo Lote</p>
                                                <h5 class="font-size-15">{{ formPro.tipo_lote }}</h5>
                                              </div>
                                            </div>
                                            <div class="col-sm-3">
                                              <div class="mt-4 mt-sm-0" style="background-color: #FFB6C1; padding: 15px; border-radius: 5px; font-size: 16px; font-weight: bold; color: black; text-align: center;">
                                                <p class="text-muted mb-2" style="color: black;">Inversión económica coral</p>
                                                <h5 style="margin: 0;">
                                                  {{ money(formPro.inversion_economica) }}
                                                </h5>
                                              </div>
                                            </div>
                                            <div class="col-sm-3">
                                              <div class="mt-4 mt-sm-0" style="background-color: #FFB6C1; padding: 15px; border-radius: 5px; font-size: 16px; font-weight: bold; color: black; text-align: center;">
                                                <p class="text-muted mb-2" style="color: black;">Total Inversion Cerdo Madre</p>
                                                <h5 style="margin: 0;">
                                                  {{ money(GranTotal) }}
                                                </h5>
                                              </div>
                                            </div>
                                            <div class="col-sm-3" v-if = " formPro.no_animales >1 && formPro.tipo_lote == 'Lactancia'|| formPro.tipo_lote == 'Destete' ">
                                              <div class="mt-4 mt-sm-0" style="background-color: #FFB6C1; padding: 15px; border-radius: 5px; font-size: 16px; font-weight: bold; color: black; text-align: center;">
                                                <p class="text-muted mb-2" style="color: black;">Total Inversion Lechones</p>
                                                <h5 style="margin: 0;">
                                                  {{ money(GranTotalLechones) }}
                                                </h5>
                                              </div>
                                            </div>

                                            <div class="col-sm-3">
                                              <div class="mt-4 mt-sm-0" style="background-color: #ADD8E6; padding: 15px; border-radius: 5px; font-size: 16px; font-weight: bold; color: white; text-align: center;">
                                                <p class="text-muted mb-2" style="color: white;">Comida Lb</p>
                                                <h5 style="margin: 0;">
                                                  {{ (formPro.inversion_comida) + ' LB' }}
                                                </h5>
                                              </div>
                                            </div>

                                              <div class="col-sm-3">
                                                <div class="mt-4 mt-sm-0" style="background-color: #FFFACD; padding: 15px; border-radius: 5px; font-size: 16px; font-weight: bold; color: black; text-align: center;">
                                                  <p class="text-muted mb-2" style="color: black;">Medicina Q</p>
                                                  <h5 style="margin: 0;">
                                                    {{ money(formPro.inversion_economica_m) }}
                                                  </h5>
                                                </div>
                                              </div>

                                              <div class="col-sm-3">
                                                <div class="mt-4 mt-sm-0" style="background-color: #E6E6FA; padding: 15px; border-radius: 5px; font-size: 16px; font-weight: bold; color: black; text-align: center;">
                                                  <p class="text-muted mb-2" style="color: black;">Medicina cm</p>
                                                  <h5 style="margin: 0;">
                                                    {{ (formPro.inversion_medicina) + ' cm' }}
                                                  </h5>
                                                </div>
                                              </div>

                                            
                                              <div class="col-sm-3" v-if="formPro.tipo_lote == 'destete' || formPro.tipo_lote == 'parto'|| formPro.tipo_lote == 'lechon engorde'">
                                              <div class="mt-4 mt-sm-0" style="background-color: #90EE90; padding: 15px; border-radius: 5px; font-size: 16px; font-weight: bold; color: white; text-align: center;">
                                                <p class="text-muted mb-2" style="color: white;">Ganancias del Lote</p>
                                                <h5 style="margin: 0;">
                                                  {{money(totalGanancias)}}
                                                </h5>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>  

                                    

                                </div>
                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card>

                      </div>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>

        <div class="card" style="margin-bottom: 0px;margin-top: 0px;">
          <div class="card-body" style=" padding-top: 0px;padding-bottom: 0px;">
            <h4 class="card-title">Listado de cerdos</h4>
            <div class="row ">
              <div class="col-sm-12 col-md-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center"> </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                v-if="detalleorden.length > 0"
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow  "
             
                :css="css.table"
                :api-mode="false"
                :fields="fields"
                :data="detalleorden"
              >

              <div slot="opciones" slot-scope="props">
                  <b-dropdown
                      text="Opciones"
                      variant="outline-primary"
                      size="sm"
                  >
                    <!-- Inversiones -->
                    <b-dropdown-item-button
                    v-if="props.rowData.estado_activo || props.rowData.cerdo.estado_animal == 'Vendido'"
                        @click="onActionClicked('inversiones-item', props.rowData)"
                        variant="outline-secondary"
                        title="Inversiones"
                    ><i class="bx bx-dish"></i> Alimento</b-dropdown-item-button>
                    <b-dropdown-item-button
                    v-if="props.rowData.estado_activo && props.rowData.cerdo.tipoAnimalId ==1"
                        @click="onActionClicked('ficha-tecnica', props.rowData)"
                        variant="outline-secondary"
                        title="Ficha Tecnica"
                    ><i class="bx bx-cog"></i> Ficha Tecnica</b-dropdown-item-button>

                    <!-- Editar -->
                    <b-dropdown-item-button
                    v-if="props.rowData.estado_activo"
                        @click="onActionClicked('medicamento-item', props.rowData)"
                        variant="outline-secondary"
                        title="Medicamento"
                    ><i class="bx bx-capsule"></i> Medicamentos</b-dropdown-item-button>

                    <!-- Eliminar -->
                    <b-dropdown-item-button
                    v-if="props.rowData.cerdo.tipoAnimalId == 2"
                        @click="onActionClicked('parto-item', props.rowData)"
                        variant="outline-secondary"
                        title="Eliminar"
                    ><i class="bx bx-trash"></i> Parto</b-dropdown-item-button>

                    <b-dropdown-item-button
                    v-if="props.rowData.cerdo.tipoAnimalId == 2 && props.rowData.cerdo.estado && props.rowData.estado_activo"
                        @click="onActionClicked('animal-muerto', props.rowData)"
                        variant="outline-secondary"
                        title="Marcar como muerto"
                    ><i class="bx bx-trash"></i>Animal muerto</b-dropdown-item-button>

                    <!-- <b-dropdown-item-button
                        @click="onActionClicked('ver-detalles', props.rowData)"
                        variant="outline-secondary"
                        title="Ver Detalles"
                    ><i class="bx bx-show"></i> Ver Detalles</b-dropdown-item-button>

                    <b-dropdown-item-button
                        @click="onActionClicked('descargar-item', props.rowData)"
                        variant="outline-secondary"
                        title="Descargar"
                    ><i class="bx bx-download"></i> Descargar</b-dropdown-item-button> -->
                    
                  </b-dropdown>
                </div>
                
              <div slot="inversion" slot-scope="props">
              <span class="text-green">
                  {{ calculoInversion(props.rowData.cerdo.animal_comidas,props.rowData.cerdo.asignacion_medicinas) }}
                </span>
              </div>

              <div slot="precio_compra" slot-scope="props"> 
                <span class="text-red">
                  {{ money(props.rowData.cerdo.precio_compra) }}
                </span>
              </div>
              
                <div slot="precio_compra" slot-scope="props">
                  {{ money(props.rowData.cerdo.precio_compra) }}
                </div>
                <div slot="peso_ingreso" slot-scope="props">
                  {{ (props.rowData.cerdo.peso_ingreso) + ' LB' }}
                </div>
                <div slot="ultimo_peso" slot-scope="props" v-if="formPro.tipo_lote == 'Destete' || formPro.tipo_lote == 'Cerdo De Engorde'">
                  {{ (props.rowData.cerdo.peso_actual) + ' LB' }}
                </div>
                <div slot="fecha_ingreso" slot-scope="props">
                  {{showDate (props.rowData.fecha_entrada) }}
                </div>
                <div slot="fecha_salida" slot-scope="props">
                  {{   props.rowData.fecha_salida =='' ? '': showDate (props.rowData.fecha_salida )  }}
                </div>
                <div slot="vida_actual" slot-scope="props">
                  {{calcularTiempoVidaCerdo (props.rowData.cerdo.semanas, props.rowData.cerdo.fecha_ingreso) }}
                </div>
                <div slot="ganancia" slot-scope="props">
                  {{money(props.rowData.cerdo.ganancia ?? 0) }}
                </div>
                <div slot="muerte" slot-scope="props">
                  {{(props.rowData.cerdo.causa_muerte) }}
                </div>
                <div slot="estado_activo" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                        v-if="props.rowData.estado_activo"
                      variant="success"
                    >
                      Activo
                    </b-button>
                    <b-button
                      v-else-if="!props.rowData.estado_activo && props.rowData.cerdo.estado_animal == 'Muerto' || props.rowData.cerdo.estado_animal == 'Momia' "
                      variant="danger"
                    >
                      Muerto
                    </b-button>
                   
                    <b-button
                      v-else-if="!props.rowData.estado_activo  && props.rowData.fecha_venta!==null  "
                      variant="danger"
                    >
                      Vendido
                    </b-button>
                    <b-button
                      v-else-if="!props.rowData.estado_activo "
                      variant="danger"
                    >
                      Traslado
                    </b-button>
                    
                  </b-button-group>
                </div>
                <div slot="embarazo" slot-scope="props" v-if="props.rowData.cerdo.tipoAnimalId==1">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                        v-if="props.rowData.cerdo.estado_embarazo == true && props.rowData.cerdo.tipoAnimalId==1"
                      variant="success"
                    >
                      Preñado
                    </b-button>
                    <b-button
                      v-else variant="danger"
                    >
                      Pendiente
                    </b-button>
                   
                    
                  </b-button-group>
                </div>
              
                <div slot="tipo_animal" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                        v-if="props.rowData.cerdo.tipoAnimalId == 1"
                      variant="success"
                    >
                    Madre
                    </b-button>
                    <b-button
                      v-else
                      variant="danger"
                    >
                      Cria
                    </b-button>
                  </b-button-group>
                </div>
              
                <!-- <div slot="ubicacion" slot-scope="props">
                  {{ props.rowData.inventario_producto.bodega.nombre_bodega }}
                </div> -->
              </vuetable>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.text-green {
  color: #28a745; /* Verde intenso */
  font-weight: bold;
  background-color: #e6f4ea; /* Fondo verde claro */
  padding: 5px 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
}

.text-red {
  color: #dc3545; /* Rojo intenso */
  font-weight: bold;
  background-color: #f8d7da; /* Fondo rojo claro */
  padding: 5px 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
}
/* Fondo gris claro */
body {
  background-color: #f7f7f7;
}

/* Contenedores con fondo blanco */
.container-main {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;
}
/* Ajuste de tamaño de fuente */
.info-box h5 {
  font-size: 14px; /* Reducido de 16px a 14px */
  font-weight: bold;
  margin: 0;
}
.text-green {
  color: #28a745; /* Verde intenso */
  font-weight: bold;
  background-color: #e6f4ea; /* Fondo verde claro */
  padding: 5px 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
}

.text-red {
  color: #dc3545; /* Rojo intenso */
  font-weight: bold;
  background-color: #f8d7da; /* Fondo rojo claro */
  padding: 5px 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
}
.info-box p {
  font-size: 12px; /* Reducido de 14px a 12px */
  color: #6c757d;
  margin-bottom: 5px;
}

/* Reducción de padding para hacer más compactos los elementos */
.info-box {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px; /* Reducido de 15px a 10px */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px; /* Reducido de 20px a 15px */
  background-color: #ffffff;
}

/* Ajustes generales para hacer los elementos más compactos */
.btn {
  padding: 6px 10px; /* Reducción en botones */
  font-size: 13px; /* Tamaño más compacto para botones */
}

.row > .col-sm-3, .row > .col-sm-4 {
  margin-bottom: 15px; /* Reducido de 20px a 15px */
}




</style>
